import { useServices } from "@/services-context";
import { NotFoundDesktop } from "./not-found-desktop";
import { NotFoundMobile } from "./not-found-mobile";
import { LocationHook, RouteHook, useLocation, useRoute } from "preact-iso";
import { LayoutTypes, useLayoutType } from "@/util-react/layout.tsx";
import { pageSuspense, useSuspenseLoader } from "@/helpers/suspense";
import { Services } from "@/services/services";

const fetchPageData = async (params: { services: Services, location: LocationHook, route: RouteHook }) => {
  const { services, location, route } = params;

  await services.initialize.prepare({
    location: location,
    route: route,
  });
};

const getPageComponent = (layoutType: LayoutTypes) => {
  switch (layoutType) {
    case LayoutTypes.TYPE_DESKTOP:
      return NotFoundDesktop;
    case LayoutTypes.TYPE_MOBILE:
      return NotFoundMobile;
  }
}

export const NotFoundPage = pageSuspense(() => {
  const route = useRoute();
  const location = useLocation();
  const services = useServices();
  const { layoutType } = useLayoutType();

  useSuspenseLoader({
    key: "not-found-route",
    loader: () => fetchPageData({
      services: services,
      location: location,
      route: route
    })
  });

  const PageComponent = getPageComponent(layoutType);

  return <PageComponent />;
});
